<div class="example-pizza-party">
    {{data}}
</div>
<a class="dismiss" (click)="dismiss()" >
  Dismiss
</a>
